import React from 'react';

interface SamGovIconProps {
  height?: number;
  className?: string;
}

export const SamGovLogo: React.FC<SamGovIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="4" fill="#003768" />
      <path
        d="M5 22H27"
        stroke="#BF0A30"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5 25H27"
        stroke="#BF0A30"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <text
        x="16"
        y="18"
        fill="white"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
        fontFamily="sans-serif"
      >
        SAM
      </text>
      <path
        d="M12 9L16 7L20 9"
        stroke="#FFD700"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
